import AccessPointModal from 'components/FrictionlessCheckout/DeliverTo/AccessPoint/AccessPointModal/AccessPointModal';

import { createSelector, createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import { orderSelector } from 'selectors/order/orderSelector';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import AccessPointModalEN from 'components/FrictionlessCheckout/DeliverTo/AccessPoint/AccessPointModal/locales/AccessPointModal_en_US';
import AccessPointModalFR from 'components/FrictionlessCheckout/DeliverTo/AccessPoint/AccessPointModal/locales/AccessPointModal_fr_CA';

const { getTextFromResource, getLocalisedDataFromResource, isCanada } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(AccessPointModalEN, AccessPointModalFR);

const { wrapHOC } = FrameworkUtils;
const fields = createStructuredSelector({
    user: userSelector,
    order: orderSelector,
    confirmButton: getTextFromResource(getText, 'confirmButton'),
    modalTitle: getTextFromResource(getText, isCanada() ? 'modalTitleCA' : 'modalTitle'),
    fedexOnsite: getTextFromResource(getText, 'fedexOnsite'),
    openUntil: getTextFromResource(getText, 'openUntil'),
    away: getTextFromResource(getText, 'away'),
    detailsModalTitle: getTextFromResource(getText, 'detailsModalTitle'),
    getDirections: getTextFromResource(getText, 'getDirections'),
    loactionHours: getTextFromResource(getText, 'loactionHours'),
    halCompany: getTextFromResource(getText, isCanada() ? 'canadaPostLocations' : 'fedexLocations'),
    pleaseTryAgain: getTextFromResource(getText, 'pleaseTryAgain')
});

const withAccessPointModalProps = wrapHOC(
    connect(
        createSelector(fields, selectorFields => {
            return {
                ...selectorFields,
                unableToFindResults: getText('unableToFindResults', [selectorFields.halCompany]),
                enterSearchParams: getText('enterSearchParams', [selectorFields.halCompany]),
                getText
            };
        })
    )
);

export default withAccessPointModalProps(AccessPointModal);
